import { JaneAvatar } from 'components/BKJJaneAvatar';
import { Flex } from 'components/Flex';
import { useFetchJaneByIdDataContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/DirectRequests/FetchJaneByJaneId.data.context';
import { InternalPay } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/InternalPay';
import { OpenPay } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/OpenPay';
import {
  SendToAgenciesBoldText,
  InfoSection,
  SendToAgenciesText,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { useSendToAgenciesFormContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useTranslation } from 'hooks/useTranslation';

export function DirectRequestsComponent() {
  const { t } = useTranslation();
  const {
    values: { post_action },
  } = useSendToAgenciesFormContext();

  const { data: fetchJaneData } = useFetchJaneByIdDataContext();

  return (
    <Flex flexDirection="column" gap="32px">
      <Flex flexDirection="column" gap="8px">
        <SendToAgenciesBoldText>{t('shift_modal:DIRECT_REQUEST')} (1)</SendToAgenciesBoldText>
        <InfoSection gap="20px" alignItems="center">
          <JaneAvatar
            size={80}
            status="pending"
            url={fetchJaneData.fetchJane.avatarUrls.small}
            pendingSignup={fetchJaneData.fetchJane.pendingSignup}
          />
          <Flex flexDirection="column">
            <SendToAgenciesBoldText>
              {`${fetchJaneData.fetchJane.firstName} ${fetchJaneData.fetchJane.lastName}`}
            </SendToAgenciesBoldText>
            <SendToAgenciesText>
              {`${t('shift_modal:REQUEST_HAVE_FOUR_HOUR_ACCEPTANCE_WINDOW_NOTE')} ${
                post_action === 'internal_only'
                  ? t('shift_modal:INTERNAL_STAFF')
                  : t('shift_modal:ALL_AVAILABLE_AGENCY_MEMBERS')
              }`}
            </SendToAgenciesText>
          </Flex>
        </InfoSection>
      </Flex>
      {post_action === 'internal_only' ? <InternalPay /> : <OpenPay />}
    </Flex>
  );
}
